<template>
    <div>
        <button class="btn btn-sm btn-secondary" @click="handleCollapseAllClick"><i class="fas fa-angle-double-up"></i> Collapse All</button>
        <button class="btn btn-sm btn-secondary ml-2" @click="handleExpandAllClick"><i class="fas fa-angle-double-down"></i> Expand All</button>
    </div>
</template>

<script>
import { EventBus } from '@/eventBus.js';

export default {
  name: 'CollapsibleCardButtons',
  props: {

  },
  components: {

  },
  data: () => {
    return {
      collapsed: false
    }
  },
  computed: {

  },
  methods: {
      handleCollapseAllClick() {  
        EventBus.$emit('collapse-all-clicked');
      },
      handleExpandAllClick() {
          EventBus.$emit('expand-all-clicked');
      }
  }
}
</script>

